const phoneNumbers: { [key: string]: string } = {
  AD: '+31 (0) 20 225 1568',
  AL: '+31 (0) 20 225 1568',
  AM: '+31 (0) 20 225 1568',
  AT: '+31 (0) 20 225 1568',
  AU: '+61 3 8777 0435',
  AX: '+31 (0) 20 225 1568',
  BA: '+31 (0) 20 225 1568',
  BE: '+31 (0) 20 225 1568',
  BG: '+31 (0) 20 225 1568',
  BR: '79 3142 3040',
  BY: '+31 (0) 20 225 1568',
  CH: '+31 (0) 20 225 1568',
  CO: '01 328 9065',
  CZ: '+31 (0) 20 225 1568',
  DE: '+31 (0) 20 225 1568',
  DK: '+31 (0) 20 225 1568',
  EE: '+31 (0) 20 225 1568',
  ES: '+31 (0) 20 225 1568',
  FI: '+31 (0) 20 225 1568',
  FO: '+31 (0) 20 225 1568',
  FR: '+31 (0) 20 225 1568',
  GB: '+44 (0) 115 697 1822',
  GG: '+31 (0) 20 225 1568',
  GI: '+31 (0) 20 225 1568',
  GL: '+31 (0) 20 225 1568',
  GR: '+31 (0) 20 225 1568',
  HR: '+31 (0) 20 225 1568',
  HU: '+31 (0) 20 225 1568',
  IE: '+31 (0) 20 225 1568',
  IM: '+31 (0) 20 225 1568',
  IS: '+31 (0) 20 225 1568',
  IT: '+31 (0) 20 225 1568',
  JE: '+31 (0) 20 225 1568',
  LI: '+31 (0) 20 225 1568',
  LT: '+31 (0) 20 225 1568',
  LU: '+31 (0) 20 225 1568',
  LV: '+31 (0) 20 225 1568',
  MC: '+31 (0) 20 225 1568',
  MD: '+31 (0) 20 225 1568',
  ME: '+31 (0) 20 225 1568',
  MK: '+31 (0) 20 225 1568',
  MT: '+31 (0) 20 225 1568',
  NL: '+31 (0) 20 225 1568',
  NO: '+31 (0) 20 225 1568',
  NZ: '+61 3 8777 0435',
  PL: '+31 (0) 20 225 1568',
  PT: '+31 (0) 20 225 1568',
  RO: '+31 (0) 20 225 1568',
  RS: '+31 (0) 20 225 1568',
  SE: '+31 (0) 20 225 1568',
  SI: '+31 (0) 20 225 1568',
  SJ: '+31 (0) 20 225 1568',
  SK: '+31 (0) 20 225 1568',
  SM: '+31 (0) 20 225 1568',
  UA: '+31 (0) 20 225 1568',
  VA: '+31 (0) 20 225 1568'
};
const countryCodeKey = 'notInEuLoaderCountry';
const defaultNumbersRegex = [
  ['888', '875', '4552'],
  ['888', '875', '1867'],
  ['888', '875', '6970'],
  ['888', '875', '1683'],
  ['877', '210', '9890']
].map(
  ([areaCode, firstThree, lastFour]) =>
    new RegExp(
      `(?:tel:)?\\+?1?[\\- ]?\\(?${areaCode}\\)?[\\- ]?${firstThree}[\\-\\s]?${lastFour}`
    )
);

export const localizePhoneNumbers = (copy?: string) => {
  const isServer = typeof window === 'undefined';
  let countryCode = '';
  try {
    if (!isServer) {
      countryCode = localStorage.getItem(countryCodeKey) || '';
    }
  } catch (e) {
    // noop
  }

  if (countryCode && countryCode in phoneNumbers) {
    let thisCopy = copy;
    defaultNumbersRegex.forEach(defaultNumbersRegexEntry => {
      if (thisCopy && thisCopy.match(defaultNumbersRegexEntry)) {
        let replacement = phoneNumbers[countryCode];
        if (thisCopy.startsWith('tel:')) {
          replacement = `tel:${
            replacement.startsWith('+') ? '' : '+'
          }${replacement.replace(/ /g, '')}`;
        }
        thisCopy = thisCopy.replace(defaultNumbersRegexEntry, replacement);
      }
    });

    return thisCopy || '';
  }

  if (isServer && copy && copy.startsWith('tel:')) {
    copy = '';
  }

  return copy || '';
};
